var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeKimono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,46.21c8.34,0,15.11-6.77,15.11-15.11s-6.77-15.11-15.11-15.11-15.11,6.77-15.11,15.11,6.77,15.11,15.11,15.11ZM50,23.55c4.17,0,7.55,3.38,7.55,7.55s-3.38,7.55-7.55,7.55-7.55-3.38-7.55-7.55,3.38-7.55,7.55-7.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.33,51.9h-5.47l-5.52,11.34-6.2-11.34h-5.47c-8.34,0-15.11,6.77-15.11,15.11v13.22c0,2.09,1.69,3.78,3.78,3.78s3.78-1.69,3.78-3.78v-13.22c0-4.17,3.38-7.55,7.55-7.55h.34l7.46,13.49-2.38,5.98c-.71,1.96.3,4.13,2.26,4.84,1.96.71,4.13-.3,4.84-2.26l9.89-22.06h.25c4.17,0,7.55,3.38,7.55,7.55v13.22c0,2.09,1.69,3.78,3.78,3.78s3.78-1.69,3.78-3.78v-13.22c0-8.34-6.77-15.11-15.11-15.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeKimono);
export default __webpack_public_path__ + "static/media/acae_kimono.6b70f10f.svg";
export { ForwardRef as ReactComponent };